const genericError = 'generic_error';
export const jpCodes = {
  genericError,
};
